module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ck-d76f3968d6f25ed0bc7d4bb559099de8.svg";